import { alpha, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  unitStyle: {
    width: "100%",
    height: "60px",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: alpha(theme.palette.colors.white || "#fff", 0.1),
    color: theme.palette.colors.white,
    marginBottom: "6px"
  },
  selected: { border: "solid 2px rgba(255, 255, 255, 0.6)" },
  tempSec: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "26px",
    height: "100%",
    width: "25%",
    flex: 1
  },
  tempInfo: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
    justifyContent: "flex-start",
    marginLeft: "5px"
  },
  iconDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1
  },
  roomTemp: {
    fontSize: "13px",
    fontWeight: 300,
    color: theme.palette.colors.white,
    display: "flex"
  },
  tempText: {
    fontSize: "23px",
    lineHeight: "unset"
  },
  locSec: {
    paddingLeft: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "bold",
    width: "35%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    maxHeight: "40px"
  },
  notesSec: {
    display: "flex",
    height: "100%",
    width: "42%",
    justifyContent: "space-between",
    alignItems: "center"
  },
  iconStyle: {
    fontSize: "17.5px",
    transform: "scale(1.389)"
  },
  modeIcon: {
    margin: "0 5px"
  },
  noteIcon: {
    fontSize: "20px",
    display: "flex"
  },
  powerAlertsSchedulesContainer: {
    alignItems: "center",
    width: "34%",
    justifyContent: "space-between",
    height: "100%",
    flexWrap: "nowrap"
  },
  smallIcons: {
    transform: "scale(0.5)",
    margin: "-10px",
    marginRight: "-4px"
  },
  notVisibile: {
    visibility: "hidden"
  },
  removeElements: {
    display: "none"
  },
  removedStyle: {
    opacity: 0.5
  },
  errorColor: {
    color: theme.palette.colors.carminePink
  },
  nameStyle: {
    fontSize: "20px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "inline-block"
  },
  alertIcon: { width: "20px", height: "20px" },
  centerWithMargin: {
    marginLeft: "5px"
  },
  tempTextSensor: {
    fontSize: "26px",
    fontWeight: 300,
    fontFamily: "RobotoLight",
    lineHeight: "normal",
    letterSpacing: "normal",
    marginLeft: 5,
    flexFlow: "row nowrap",
    alignItems: "flex-end"
  },
  offText: {
    color: alpha(theme.palette.colors.white || "#fff", 0.4)
  },
  boldText: {
    fontFamily: "RobotoMedium",
    fontWeight: 500
  },
  onOffSensor: {
    display: "flex",
    alignItems: "center",
    width: "34%",
    justifyContent: "flex-end",
    height: "100%"
  },
  importantNoteSec: {
    display: "flex",
    height: "100%",
    width: "20px",
    justifyContent: "space-between",
    alignItems: "center"
  },
  optionalNoteSec: {
    display: "flex",
    height: "100%",
    width: "20px",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 365px)": {
      display: "none"
    }
  },
  offStyle: {
    color: alpha(theme.palette.colors.gray5 || "#fdfdfe", 0.6)
  },
  disconnectedContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  },
  disconnectedIconStyle: {
    transform: "scale(2.5)"
  },
  nameStyle2Lines: {
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    lineHeight: "20px",
    whiteSpace: "unset",
    maxHeight: 40,
    fontSize: "0.9rem",
    overflow: "unset",
    overflowWrap: "anywhere"
  },
  specialFont: {
    fontFamily: "-webkit-body",
    fontSize: "16px",
    alignItems: "flex-end"
  },
  powerUnit: {
    fontSize: "16px",
    lineHeight: "24px",
    marginLeft: "4px"
  }
}));

export default useStyles;
